import { useAccountFormContext } from '../../context';
import { FormFieldV2 } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { accountTypeOptions } from './cols';

function GeneralTab() {
  const { mode, markDirty } = useAccountFormContext();
  const isViewMode = mode === 'view';

  return (
    <div className='h-full overflow-y-auto p-4' onChangeCapture={markDirty}>
      <div className='space-y-1'>
        <div className='flex flex-col sm:flex-row sm:items-center'>
          <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên ngắn</Label>
          <FormFieldV2 type='text' name='short_name_1' className='w-[400px]' disabled={isViewMode} />
        </div>

        <div className='flex flex-col sm:flex-row sm:items-center'>
          <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên ngắn khác</Label>
          <FormFieldV2 type='text' name='short_name_2' className='w-[400px]' disabled={isViewMode} />
        </div>

        <div className='flex items-center gap-2'>
          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tài khoản sổ cái</Label>
            <FormFieldV2 type='checkbox' name='tk_so_cai' disabled={isViewMode} />
          </div>
          <div className='ml-8 flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Ngoại tệ gốc</Label>
            <FormFieldV2
              type='select'
              name='currency_code'
              options={[
                { value: 'VND', label: 'VND' },
                { value: 'USD', label: 'USD' },
                { value: 'EUR', label: 'EUR' },
                { value: 'JPY', label: 'JPY' }
              ]}
              className='w-[100px]'
              disabled={isViewMode}
            />
          </div>
        </div>

        <div className='flex flex-col sm:flex-row sm:items-center'>
          <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>TK theo dõi công nợ</Label>
          <FormFieldV2
            type='select'
            name='ar_ap_tracking_type'
            options={[
              { value: 0, label: '0. Không theo dõi công nợ' },
              { value: 1, label: '1. Công nợ phải thu' },
              { value: 2, label: '2. Công nợ phải trả' },
              { value: 3, label: '3. Công nợ khác' }
            ]}
            className='w-[400px]'
            disabled={isViewMode}
          />
        </div>

        <div className='flex flex-col sm:flex-row sm:items-center'>
          <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Phân loại tài khoản</Label>
          <FormFieldV2
            type='select'
            name='account_type_code'
            className='w-[400px]'
            options={accountTypeOptions}
            disabled={isViewMode}
          />
        </div>

        <div className='flex flex-col sm:flex-row sm:items-center'>
          <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>PP tính TGNS nợ</Label>
          <FormFieldV2
            type='select'
            name='fx_reval_debit_type'
            options={[
              { value: 0, label: '0. Không tính chênh lệch' },
              { value: 1, label: '1. Phát sinh trong kỳ' },
              { value: 2, label: '2. Số dư cuối kỳ' }
            ]}
            className='w-[400px]'
            disabled={isViewMode}
          />
        </div>

        <div className='flex flex-col sm:flex-row sm:items-center'>
          <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>PP tính TGNS có</Label>
          <FormFieldV2
            type='select'
            name='fx_reval_credit_type'
            options={[
              { value: 0, label: '0. Không tính chênh lệch' },
              { value: 1, label: '1. Phát sinh trong kỳ' },
              { value: 2, label: '2. Số dư cuối kỳ' }
            ]}
            className='w-[400px]'
            disabled={isViewMode}
          />
        </div>

        <div className='flex flex-col pt-2 sm:flex-row sm:items-center'>
          <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tài khoản chi tiết</Label>
          <FormFieldV2 type='checkbox' name='tk_chi_tiet' disabled={isViewMode} />
        </div>

        <div className='flex flex-col sm:flex-row sm:items-center'>
          <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Ghi chú</Label>
          <FormFieldV2 type='text' name='notes' className='w-[400px]' disabled={isViewMode} />
        </div>

        <div className='flex flex-col sm:flex-row sm:items-center'>
          <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Trạng thái</Label>
          <FormFieldV2
            type='select'
            name='active'
            options={[
              { value: true, label: '1. Còn sử dụng' },
              { value: false, label: '0. Không sử dụng' }
            ]}
            className='w-[400px]'
            disabled={isViewMode}
          />
        </div>
      </div>
    </div>
  );
}

export default GeneralTab;
